export const LINKED_LOGO_PREFIX = "LinkedLogo";

export const LINKED_LOGO_CLASSES = {
  logoLink: `${LINKED_LOGO_PREFIX}-logoLink`,
  logoImage: `${LINKED_LOGO_PREFIX}-logoImage`,
};
